import React, { useEffect, useRef } from "react";
import Classes from "./EraserCursor.module.css";

const EraserCursor = (props) => {
  const eraserCursor = useRef(null);
  const cursorVisible = useRef(true);

  const endX = useRef(window.innerWidth / 2);
  const endY = useRef(window.innerHeight / 2);
  // const _x = useRef(0);
  // const _y = useRef(0);

  // const requestRef = useRef(null);

  useEffect(() => {
    document.addEventListener("mousemove", mouseMoveEvent);
    document.addEventListener("mouseenter", mouseEnterEvent);
    document.addEventListener("mouseleave", mouseLeaveEvent);

    return () => {
      document.removeEventListener("mousemove", mouseMoveEvent);
      document.removeEventListener("mouseenter", mouseEnterEvent);
      document.removeEventListener("mouseleave", mouseLeaveEvent);
    };
  });

  const toggleCursorVisibility = () => {
    if (cursorVisible.current) {
      eraserCursor.current.style.opacity = 1;
    } else {
      eraserCursor.current.style.opacity = 0;
    }
  };

  const mouseEnterEvent = () => {
    cursorVisible.current = true;
    toggleCursorVisibility();
  };

  const mouseLeaveEvent = () => {
    cursorVisible.current = false;
    toggleCursorVisibility();
  };

  const mouseMoveEvent = (e) => {
    cursorVisible.current = true;
    toggleCursorVisibility();

    endX.current = e.pageX;
    endY.current = e.pageY;

    eraserCursor.current.style.top = endY.current + "px";
    eraserCursor.current.style.left = endX.current + "px";
  };

  return (
    <>
      <div ref={eraserCursor} className={Classes.cursor}></div>
    </>
  );
};
export default EraserCursor;
